var scope_0 = require('/Users/jason/Documents/Workspace/VSCode/Nualang/nualang.com/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/33cdef9023bf8dcfdf3fb3b3d38141e7.js').default;
var scope_1 = require('/Users/jason/Documents/Workspace/VSCode/Nualang/nualang.com/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e92f8988d65cf25c087d226e6c0ef06f.js').default;export default
        Object.assign({}, scope_0,
scope_1 )
    